class AstQuantity extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector(".ast-qty__input");
    this.btnMinus = this.querySelector('[name="minus"]');
    this.btnPlus = this.querySelector('[name="plus"]');

    this.btnMinus.addEventListener("click", this.decrease.bind(this));
    this.btnPlus.addEventListener("click", this.increase.bind(this));
  }

  decrease() {
    let value = parseInt(this.input.value);
    if (value > 1) {
      this.input.value = value - 1;
      this.input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  increase() {
    let value = parseInt(this.input.value);
    let max = this.input.getAttribute("max");

    if (!max || value < parseInt(max)) {
      this.input.value = value + 1;
      this.input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
}

if (!customElements.get("ast-quantity")) {
  customElements.define("ast-quantity", AstQuantity);
}
